import { FaArrowDown, FaArrowUp } from "react-icons/fa6";

const ProductsView = ({ startYear, endYear, records }) => {
  const years = Array.from(
    { length: endYear - startYear + 1 },
    (_, i) => startYear + i,
  );

  const productRows = Object.values(
    records.reduce((acc, item) => {
      const year = Number(String(item.month).slice(0, 4));
      const category = item.root_category_name;
      if (!acc[category]) {
        const yearly = years.reduce((res, currentYear) => {
          res[currentYear] = { qty: 0 };
          return res;
        }, {});

        acc[category] = { category, yearly };
      }

      if (acc[category].yearly[year]) {
        acc[category].yearly[year].qty += item.total_qty || 0;
      }

      return acc;
    }, {}),
  ).sort((a, b) => a.category.localeCompare(b.category));

  return (
    <div className="card">
      <h5>Products</h5>
      <div className="mt-2 -mx-1">
        <div className="font-code">
          <table className="with-border">
            <thead>
              <tr>
                <th>Category</th>
                {years.map((year) => (
                  <th key={`${year}-qty`} className="text-right">
                    {year} QTY
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {productRows.map((row) => (
                <tr key={row.category}>
                  <td>{row.category}</td>
                  {years.map((year, index) => {
                    const qty = row.yearly[year].qty;
                    const prevYear = years[index - 1];
                    const prevQty = prevYear ? row.yearly[prevYear].qty : null;
                    const isUp = prevQty !== null && qty > prevQty;
                    const isDown = prevQty !== null && qty < prevQty;

                    return (
                      <td
                        key={`${row.category}-${year}-qty`}
                        className="text-right"
                      >
                        <span
                          className={`inline-flex items-center justify-end gap-1 ${
                            isUp
                              ? "text-green-600"
                              : isDown
                                ? "text-red-600"
                                : ""
                          }`}
                        >
                          {isUp && <FaArrowUp size={11} />}
                          {isDown && <FaArrowDown size={11} />}
                          <span>{qty.toLocaleString()}</span>
                        </span>
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ProductsView;
